module.exports = __webpack_public_path__ + "img/section1SwiperTab2.7c503a20.png";